import { State } from '@progress/kendo-data-query';

const getDefaultGridState = (take: number =  50) : State => {
    return {
        take: take,
        skip: 0,
        sort: [],
        filter: { logic: "and", filters: []}
    };
}

export default  getDefaultGridState;